<template>
  <b-modal
    v-if="item"
    id="MobileCart"
    class="dine-add-card"
    size="md"
    centered
    :hide-footer="true"
    :title="_T_DB(item, 'name')"
  >
    <div class="customized-modal" role="document">
      <div class="modalcontent">
        <div class="modalbody ratio_portrait">
          <Top></Top>
          <div class="customized-detail">
            <ItemInfo></ItemInfo>
            <Modifiers></Modifiers>
            <Bottom></Bottom>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from './top'
import ItemInfo from '../Items/ItemDetail/ItemInfo'
import Modifiers from '../Items/ItemDetail/SelectModifiers'
import Bottom from './bottom'
export default {
  name: 'ItemDetail',
  props: { item: Object },
  components: {
    Top,
    ItemInfo,
    Modifiers,
    Bottom,
  },
  computed: {
    ...mapGetters(['_T', '_T_DB', 'hasModifiers', 'item_modifiers_price']),
  },
}
</script>

<style lang="scss">
#MobileCart {
  .modal-dialog {
    width: $px500 !important;
    max-width: $px500 !important;
    margin: 0.5rem auto !important;
    .modal-title {
      font-weight: 600;
      font-size: $px18;
      line-height: $px22;
      letter-spacing: 0.02em;
      color: $font-color;
      text-transform: capitalize;
      margin-bottom: 0;
    }
    .customized-modal {
      .bg-size {
        border-radius: $px4;
      }
      .customized-title {
        display: none;
        .close {
          display: none;
        }
      }
      .customized-price,
      .total-box {
        display: none;
      }
      .modal-bottom {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-top: $px1 solid $light-border;
        padding: $px15 $px15;
      }
    }
  }
}
@media (max-width: 575px) {
  #MobileCart {
    .modal-dialog {
      position: relative;
      width: auto !important;
      margin: 0.5rem !important;
      pointer-events: none;
      max-width: 100% !important;
      .modal-content {
        border: none !important;
        .modal-bottom {
          .qty-title {
            display: none;
          }
          .qty-box {
            margin-left: 0;
          }
          a {
            &.btn {
              padding: $px8 $px10;
            }
          }
        }
      }
    }
  }
}
</style>
